import { Icon } from "PFComponents/icon";
import DoubleArrowIcon from "PFIcons/double_arrow_horizontal.svg";
import React from "react";

import css from "../bars.module.scss";
import { useBookingBarContext } from "./booking_bar_provider";
import { BookingPillLabel } from "./booking_pill_label";
import { SplitModeOverlay } from "./split_mode_overlay/split_mode_overlay";

const allBookingsModeIcon = <Icon name="shown" />;

export const BookingPillContent = (): JSX.Element | null => {
  const {
    bar: {
      width,
      duration,
      title,
      titleDisabled,
      calculatedLoad,
      isAllBookingsModeEnabled,
      isRelatedToParentRowActivity
    },
    draggingMode,
    category,
    isSplittable
  } = useBookingBarContext();

  if (!category) {
    return null;
  }
  const showIcon = isAllBookingsModeEnabled && !isRelatedToParentRowActivity;
  const minWidthForTitle = showIcon ? 110 : 90;
  const showTitle = !titleDisabled && width > minWidthForTitle;
  const minWidthForLabel = showIcon ? (showTitle ? 125 : 75) : showTitle ? 105 : 55;
  const showLabel = width > minWidthForLabel;

  return (
    <>
      {!isSplittable && (
        <>
          {width > 45 && (
            <BookingPillLabel
              title={title}
              duration={duration}
              load={calculatedLoad}
              icon={allBookingsModeIcon}
              showTitle={showTitle}
              showLabel={showLabel}
              showIcon={showIcon}
            />
          )}
          {draggingMode === "start_end" && (
            <div className={css.dragIconContainer}>
              <DoubleArrowIcon width={20} height={20} />
            </div>
          )}
        </>
      )}
      {isSplittable && <SplitModeOverlay />}
    </>
  );
};
